









































import { Component, Vue, Ref, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";

import StudentForm from "@/components/StudentForm/StudentForm.vue";

import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";

import { IStudentPayload, IStudent } from "@/models/interfaces/students";
import { AxiosResponse } from "axios";

import RequestState from "@/utils/mixins/RequestState";
import { equals, reject } from "ramda";
import { eventCodeByName, EventsNames } from "@/analytics";
import amplitude from "amplitude-js";

interface RefObserverType extends Vue {
  reset(): void;
}

interface StudentFormType {
  setLoadingState: (state: boolean) => void;
}

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    StudentForm,
    BasePopup,
    BaseButton,
    Spinner,
    Alert
  }
})
export default class StudentsAddView extends Mixins(RequestState) {
  @Ref("form")
  private form!: HTMLFormElement & StudentFormType;

  @State("student", { namespace: "students" })
  private student!: IVuexState<IStudent>;

  @Action("students/editStudent")
  private editStudent!: (data: {
    payload: IStudentPayload;
    studentId: string;
  }) => Promise<AxiosResponse>;

  @Action("students/fetchStudentById")
  private fetchStudentById!: (studentId: string) => Promise<AxiosResponse>;

  private showValidationPopup = false;
  private popupMessage = "";
  private redirectOnPopupClose = false;

  private showPopup(message: string) {
    this.popupMessage = message;
    this.showValidationPopup = true;
  }

  private onPopupClose() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksOkOnPopupAfterStudentEdit)} ${
          EventsNames.UserClicksOkOnPopupAfterStudentEdit
        }`
      );

    this.showValidationPopup = false;

    if (this.redirectOnPopupClose) {
      this.$router.push("/students");
    }
  }

  private onEditStudent(form: IStudentPayload) {
    this.form.setLoadingState(true);

    const clearedForm = reject(equals(""))(form) as IStudentPayload;

    this.editStudent({
      payload: clearedForm,
      studentId: this.$route.params.studentId
    })
      .then(() => {
        this.popupMessage = this.$t("views.students.messages.update") as string;
        this.showValidationPopup = true;
        this.redirectOnPopupClose = true;
      })
      .finally(() => {
        this.form.setLoadingState(false);
      });
  }

  public mounted() {
    const { studentId } = this.$route.params;

    this.fetchStudentById(studentId);
  }
}
